import { render } from "./VODFolderGrid.vue?vue&type=template&id=1ecb981b"
import script from "./VODFolderGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./VODFolderGrid.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/VODFolderGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ecb981b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ecb981b', __exports__)) {
    api.reload('1ecb981b', __exports__)
  }
  
  module.hot.accept("./VODFolderGrid.vue?vue&type=template&id=1ecb981b", () => {
    api.rerender('1ecb981b', render)
  })

}


export default __exports__